import { render, staticRenderFns } from "./CommunicationsTable.vue?vue&type=template&id=b21bc5e0"
import script from "./CommunicationsTable.vue?vue&type=script&lang=js"
export * from "./CommunicationsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports